// Utility to prefix language
// Returns the href without prefix for 'en' and 'us' languages
// Returns the href with language prefix for other languages (e.g., '/fr/search' for French)
export function withLangPrefix(href, lang = 'us') {
  if (!href || !href.startsWith('/')) return href;
  if (!lang || lang === 'us' || lang === 'en') return href;

  const languageCode = lang.split(/[-_]/)[0];
  if (languageCode === 'us' || languageCode === 'en') return href;

  return `/${languageCode}${href}`;
}
